import React from 'react';
import styles from '../styles.module.scss';
import convertToReadable from '@/helpers/convertToReadable';
import { Button } from 'rsuite';
import { motion } from 'framer-motion';
import { IoHeartOutline, IoHeartSharp } from 'react-icons/io5';
import IconCart from '@/assets/icons/icon-shopping-cart.svg';
import CompareActive from '@/assets/icons/compare-active.svg';
import IconCompare from '@/assets/icons/icon-compare.svg';
import { useTranslations } from 'next-intl';
import { useRouter } from '@/i18n/navigation';
import { ProductBtnGroupProps } from '@/types/categoryCard-types';
import IconCartActive from '@/assets/icons/cart/shopping-cart-added.svg';

const ProductBtnGroup = ({
  id,
  comp,
  price,
  discount,
  addToCart,
  isCompare,
  isFavorite,
  addToFavorite,
  isInComparison,
  isVariantExist,
  addToComparison,
  removeFromFavorite,
  priceUndiscounted,
  removeFromComparison,
}: ProductBtnGroupProps) => {
  const router = useRouter();
  const t = useTranslations('General');

  return (
    <div className={styles.bottomContent}>
      <div className={comp ? styles.bottomSectionComp : styles.bottomSection}>
        <div className={styles.prices}>
          {discount !== 0 ? (
            <>
              <p className={styles.discount}>
                {convertToReadable(priceUndiscounted)} {t('price')}
              </p>
              <p className={styles.price}>
                {convertToReadable(price)} {t('price')}
              </p>
            </>
          ) : (
            <p className={styles.price}>
              {convertToReadable(priceUndiscounted)} {t('price')}
            </p>
          )}
        </div>
        <div className={comp ? styles.btnGroupComp : styles.btnGroup}>
          <Button
            onClick={e => {
              e.preventDefault();
              e.stopPropagation();
              isInComparison ? removeFromComparison(id) : addToComparison(id);
            }}
            type="button"
            style={{
              display: isCompare ? 'none' : 'block',
            }}
            className={styles.compare}
          >
            {isInComparison ? <CompareActive /> : <IconCompare />}
          </Button>

          <motion.div
            whileTap={{ scale: 2 }}
            transition={{ duration: 0.5 }}
            onClick={e => {
              e.preventDefault();
              e.stopPropagation();
              isFavorite(id) ? removeFromFavorite(id) : addToFavorite(id);
            }}
            style={{
              cursor: 'pointer',
            }}
          >
            {isFavorite(id) ? (
              <Button type="button" className={styles.redLike}>
                <IoHeartSharp size={25} color="red" />
              </Button>
            ) : (
              <Button type="button" className={styles.like}>
                <IoHeartOutline size={25} />
              </Button>
            )}
          </motion.div>
          {isVariantExist ? (
            <Button
              type="button"
              onClick={e => {
                e.preventDefault();
                e.stopPropagation();
                router.push('/cart');
              }}
              className={styles.cart}
            >
              <IconCartActive />
            </Button>
          ) : (
            <Button
              type="button"
              onClick={e => {
                e.preventDefault();
                e.stopPropagation();
                addToCart(id);
              }}
              className={styles.cart}
            >
              <IconCart />
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductBtnGroup;
